(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel"] && !Shopify.designMode) return;
  try {
    
  if (!window.__carouselLightboxReady) {
    window.__carouselLightboxReady = true;

    function getOverlay() {
      var overlay = document.getElementById('carousel-lightbox');
      if (overlay) return overlay;

      overlay = document.createElement('div');
      overlay.id = 'carousel-lightbox';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');

      var closeBtn = document.createElement('button');
      closeBtn.id = 'carousel-lightbox-close';
      closeBtn.setAttribute('aria-label', 'Fermer');
      closeBtn.textContent = '×';
      overlay.appendChild(closeBtn);

      var img = document.createElement('img');
      img.id = 'carousel-lightbox-img';
      img.alt = '';
      overlay.appendChild(img);

      document.body.appendChild(overlay);

      function closeLightbox() {
        overlay.classList.remove('carousel-lightbox--active');
        document.body.style.overflow = '';
      }

      overlay.addEventListener('click', function (e) {
        if (e.target === closeBtn || e.target === overlay) closeLightbox();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('carousel-lightbox--active')) {
          closeLightbox();
        }
      });

      return overlay;
    }

    function getBestSrc(img) {
      if (!img.srcset) return img.src;
      var entries = img.srcset.split(',').map(function (s) {
        var parts = s.trim().split(/\s+/);
        return { url: parts[0], w: parseInt(parts[1]) || 0 };
      });
      entries.sort(function (a, b) { return b.w - a.w; });
      return entries[0].url || img.src;
    }

    document.addEventListener('click', function (e) {
      var card = e.target.closest('[data-carousel-card]');
      if (!card) return;

      var img = card.querySelector('.background-image-container img, .image-block__image');
      if (!img) return;

      e.preventDefault();
      e.stopPropagation();

      var overlay = getOverlay();
      var lightboxImg = document.getElementById('carousel-lightbox-img');
      lightboxImg.src = getBestSrc(img);
      lightboxImg.alt = img.alt || '';

      overlay.classList.add('carousel-lightbox--active');
      document.body.style.overflow = 'hidden';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
